module.exports = __webpack_public_path__ + "img/matanot_yes.8faf58a1.png";